<template>
    <table class="table" v-loading="loading">
        <thead>
        <tr>
            <th>{{trans('datastudio_reports.fields.name')}}</th>
            <th>{{trans('datastudio_reports.fields.link')}}</th>
            <th>{{trans('general.actions')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="report in tempReports">
            <td>
                <input type="text" class="form-control" v-model="report.name">
            </td>
            <td>
                <input class="form-control" type="text" v-model="report.link">
            </td>
            <td>
                <button class="btn btn-link" @click="update(report.id)">{{trans('buttons.update')}}
                </button>
                <button class="btn btn-link text-danger" @click="remove(report.id)"><span class="fa fa-trash"></span>
                </button>
            </td>
        </tr>
        <tr>
            <td>
                <input type="text" class="form-control" v-model="newReport.name">
            </td>
            <td>
                <input class="form-control" type="text" v-model="newReport.link">
            </td>
            <td>
                <button type="button" class="btn btn-success" @click="create()">{{trans('buttons.create')}}
                </button>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    import {Message, Notification} from 'element-ui';

    export default {
        props: {
            reports: Array,
            project: Object,
        },
        name: "project-data-studio-reports-edit",
        data() {
            return {
                tempReports: this.reports,
                newReport: {},
                loading: false,
            }
        },
        methods: {
            trans(path) {
                return Lang.trans(path);
            },
            handleRemove(report) {
                let vm = this;
                vm.loading = true;

                axios.post(laroute.route('json.project.datastudio-reports.delete', {
                    report: report.id,
                    project: vm.project.id
                }), report)
                    .then(response => {

                        if (response.data.success) {
                            vm.loading = false;
                            vm.tempReports = _.filter(vm.tempReports, function(temp){
                                return temp.id !== report.id;
                            });
                            Message.success('Removed');
                            window.vueApp.$broadcast('datastudio-reports-updated.' + vm.project.id, vm.tempReports);

                        } else {
                            Message.error('Error trying to save report');
                        }

                    })
                    .catch(e => {
                        vm.loading = false;
                        console.log(e);

                        Message.error('Error trying to remove report');


                    });
            },
            remove(id) {
                let vm = this;

                let report = _.first(this.tempReports, function (report) {
                    return report.id === id;
                });
                if (report) {
                    this.$confirm('This will permanently delete the report. Continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        vm.handleRemove(report);

                    }).catch(() => {

                    });
                }

            },
            update(id) {
                let report = _.first(this.tempReports, function (report) {
                    return report.id === id;
                });
                if (report) {
                    this.loading = true;
                    let vm = this;

                    axios.post(laroute.route('json.project.datastudio-reports.update', {
                        report: report.id,
                        project: vm.project.id
                    }), report)
                        .then(response => {

                            if (response.data.success) {
                                vm.loading = false;

                                Message.success('Saved');
                                window.vueApp.$broadcast('datastudio-reports-updated.' + vm.project.id, vm.tempReports);

                            } else {
                                Message.error('Error trying to save report');
                            }

                        })
                        .catch(e => {
                            vm.loading = false;
                            console.log(e);

                            if (e.response.status === 422) { //Unprocessable Entity - Validation error
                                console.log(e.response.data);

                                for (let field in e.response.data.errors) {
                                    // console.log(field, response[field]);
                                    Notification.error({
                                        title: 'Error',
                                        message: e.response.data.errors[field][0],
                                        offset: 100,
                                    })
                                }

                            }
                            else {
                                Message.error('Error trying to save report');
                            }

                        });
                }
            },
            create() {
                this.loading = true;
                let vm = this;

                axios.post(laroute.route('json.project.datastudio-reports', {
                    project: vm.project.id
                }), vm.newReport)
                    .then(response => {

                        if (response.data.success) {
                            vm.loading = false;
                            vm.tempReports.push(response.data.success);

                            Message.success('Saved');
                            vm.newReport = {};
                            window.vueApp.$broadcast('datastudio-reports-updated.' + vm.project.id, vm.tempReports);


                        } else {
                            Message.error('Error trying to save report');
                        }

                    })
                    .catch(e => {
                        vm.loading = false;
                        console.log(e);

                        if (e.response.status === 422) { //Unprocessable Entity - Validation error
                            console.log(e.response.data);

                            for (let field in e.response.data.errors) {
                                // console.log(field, response[field]);
                                Notification.error({
                                    title: 'Error',
                                    message: e.response.data.errors[field][0],
                                    offset: 100,
                                })
                            }

                        }
                        else {
                            Message.error('Error trying to save report');
                        }

                    });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/ProjectDataStudioReportsEdit.vue